package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.closing_reports.FinalReportsGroupEnum
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomRadioInput
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.dom.RadioGroup

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun FinancialGroupDialog(
    modifier: Modifier = Modifier,
    selectedType: FinalReportsGroupEnum,
    submitFilterItems: (FinalReportsGroupEnum) -> Unit,
    onCloseFilterClick: () -> Unit,
    loading: Boolean,
)
{
    val newSelectedPeriodType= remember{ mutableStateOf(selectedType) }

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onCloseFilterClick()
            }
    ){
        Column(
            modifier = modifier
                .align(Alignment.Center)
                .margin(top = Dimen.normalPadding)
                .width(Dimen.daysFilterDialogWidth)
                .height(Dimen.daysFilterDialogHeight)
                .generalDialogSetting()
                .zIndex(Constants.ZIndex.mediumZIndex)
                .border(
                    width= Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.ActionDisabledBackground.rgb
                ) ,
            horizontalAlignment = Alignment.CenterHorizontally

        ) {

            DialogTitle(
                title = Strings.current().group,
                showSeparator = false,
                showCloseIcon = true,
                leftRightPadding = Dimen.largePadding
            ) {
                onCloseFilterClick()
            }



            Column(
                modifier = Modifier
                    .padding(Dimen.largePadding)
                    .weight(1f)
                    .fillMaxWidth()
            )
            {
                RadioGroup(newSelectedPeriodType.value.title) {
                    FinalReportsGroupEnum.entries.forEach{ filter ->
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier
                                .cursor(Cursor.Pointer)
                                .position(Position.Relative)
                                .height(Dimen.radioButtonRowHeight)
                                .rippleEffect {
                                    if (filter != newSelectedPeriodType.value)
                                        newSelectedPeriodType.value=filter
                                }
                        )
                        {
                            CustomRadioInput(
                                title = filter.title,
                                checked = filter==newSelectedPeriodType.value,
                                onClick = {  },

                            )
                        }
                    }
                }

                Spacer()

                CustomButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    loading = loading,
                    title = Strings.current().apply,
                    buttonType = ButtonTypes.CONTAINED,
                    onButtonClick = {
                        submitFilterItems(
                            newSelectedPeriodType.value
                        )
                    },
                )
            }





        }
    }






}